/* Reusable collapsible regions ("Toon meer / minder") — works on any [data-collapse].
 *   [data-collapse][data-collapse-height]  container (toggles .is-collapsible / .is-expanded)
 *     [data-collapse-body]                  the clamped content
 *     [data-collapse-toggle]                one or more toggles (.collapsible-toggle__text optional) */
(() => {
  const THRESHOLD = 8;
  const limit = (el) => parseInt(el.dataset.collapseHeight, 10) || 280;
  const body = (el) => el.querySelector('[data-collapse-body]');

  const syncToggles = (el, expanded) =>
    el.querySelectorAll('[data-collapse-toggle]').forEach((t) => {
      const text = t.querySelector('.collapsible-toggle__text');
      const label = expanded ? t.dataset.labelLess : t.dataset.labelMore;
      if (text && label) text.textContent = label;
      t.setAttribute('aria-expanded', expanded);
    });

  const setExpanded = (el, expanded) => {
    const content = body(el);
    if (!content) return;
    el.classList.toggle('is-expanded', expanded);
    content.style.maxHeight = expanded ? `${content.scrollHeight}px` : `${limit(el)}px`;
    syncToggles(el, expanded);
  };

  const refresh = (el) => {
    const content = body(el);
    if (!content) return;
    const collapsible = content.scrollHeight > limit(el) + THRESHOLD;
    el.classList.toggle('is-collapsible', collapsible);
    if (!collapsible) {
      el.classList.remove('is-expanded');
      content.style.maxHeight = '';
    } else if (!el.classList.contains('is-expanded')) {
      setExpanded(el, false);
    }
  };

  const init = (el) => {
    if (el.dataset.collapseReady) return;
    el.dataset.collapseReady = 'true';

    el.querySelectorAll('[data-collapse-toggle]').forEach((t) =>
      t.addEventListener('click', () => {
        if (el.classList.contains('is-collapsible')) {
          setExpanded(el, !el.classList.contains('is-expanded'));
        }
      })
    );

    refresh(el);
    if (window.ResizeObserver) {
      new ResizeObserver(() => el.classList.contains('is-expanded') || refresh(el)).observe(body(el));
    }
  };

  const initAll = (root = document) => root.querySelectorAll('[data-collapse]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Theme editor support.
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const el = e.target.closest('[data-collapse]');
    if (el) setExpanded(el, true);
  });
})();
